import React from 'react';
import DefaultBg from '../../images/shapes/bg_pattern_4.svg';

const PageTitle = ({ pageTitle, pageTop, pagesub, bgImage }) => {
    const backgroundImage = bgImage || DefaultBg;

    return (
        <section className="page_banner_section">
            <img
                src={backgroundImage}
                alt="Background"
                className="background_image"
            />
            <div className="overlay"></div>

            <div className="container">
                <div className="banner_content">
                    {pageTop && (
                        <div className="page_top">
                            {pageTop}
                            {pagesub && <span className="badge bg-secondary">{pagesub}</span>}
                        </div>
                    )}
                    <h1 className="page_title">{pageTitle}</h1>
                </div>
            </div>
        </section>
    );
};

export default PageTitle;